angular
    .module('tmx-app')
    .factory('CurrentUserService',["$http",'ENV', function ($http,ENV) {
        var User={};

        return {
            getUserName: function () {
                return getUserObject().emailAddress;
            },
            firstLoginSetup: function () {
                 
                return $http.get(ENV.backend + '/tenant/AuthorizeAndCreateUserInMF',{});
            },
            getUserObject: function (property) {
                return JSON.parse(localStorage.getItem("user"));
            },
            setUser: function(user){
                User = user;

            },
            getUser: function(){
                return User;
            }

        };

    }]);